import {
  feedbackPage
} from '@/api/feedback-manage'

export default {
  state: {
    list: [],
    feedbackLoading: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setFeedbackList (state, list) {
      state.list = list
    },
    setFeedbackLoading (state, loading) {
      state.feedbackLoading = loading
    },
    setFeedbackPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setFeedbackPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setFeedbackTotal (state, total) {
      state.total = total
    },
  },
  getters: {
    feedbackList: state => state.list,
    feedbackTotal: state => state.total,
    feedbackLoading: state => state.feedbackLoading
  },
  actions: {
    getFeedbackPage ({ state, commit }, param) {
      commit('setFeedbackLoading', true)
      return new Promise((resolve, reject) => {
        feedbackPage(param).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          debugger
          commit('setFeedbackList', list)
          commit('setFeedbackLoading', false)
          commit('setFeedbackPageSize', pageSize)
          commit('setFeedbackPageNum', pageNum)
          commit('setFeedbackTotal', total)
          resolve()
        }).catch(err => {
          commit('setFeedbackLoading', false)
          reject(err)
        })
        })
      }
    }
  }


// WEBPACK FOOTER //
// ./src/store/module/feedback-manage.js